<c-card class="mb-5">

    <c-card-body>


        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="mb-0 border">


                <ng-container matColumnDef="Date" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                     Date
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.timestamp | date:'medium'}}</td>
                </ng-container>
                <ng-container matColumnDef="Hash Code" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Hash Code
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.hash}}</td>
                </ng-container>

                <ng-container matColumnDef="direction" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Direction
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.direction}}</td>
                </ng-container>
                <ng-container matColumnDef="token" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Token
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.token}}</td>
                </ng-container>

                <ng-container matColumnDef="Sender" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Sender
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.from}}</td>
                </ng-container>

                <ng-container matColumnDef="Receiver" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        Receiver
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.to}}</td>
                </ng-container>

                <ng-container matColumnDef="value" *ngIf="!isLoading">
                    <th mat-header-cell *matHeaderCellDef>
                        value
                    </th>
                    <td style="cursor: pointer;" mat-cell *matCellDef="let element">{{element.value}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{ 'hide-data': isLoading }">
                </tr>
            </table>
            <div *ngIf="isLoading" class="spinner-container">
                <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
                </mat-progress-spinner>
            </div>
        </div>
        <!-- Paginator -->
        <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            (page)="pageChanged($event)">
        </mat-paginator>



    </c-card-body>
</c-card>